import { useState } from "react"

interface UseCompanyContactFilterReturn {
  filterDrawerOpen: boolean
  setFilterDrawerOpen: (open: boolean) => void
}

export const useCompanyContactFilter = (): UseCompanyContactFilterReturn => {
  const [filterDrawerOpen, setFilterDrawerOpen] = useState<boolean>(false)

  return {
    filterDrawerOpen,
    setFilterDrawerOpen,
  }
}
